var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"web-component-bg\"> <div class=\"web-component-center\"> <div class=\"reservation-types\"> <a ng-repeat=\"slide in $ctrl.Slides track by $index\" ng-href=\"{{ slide.LinkUrl }}\" style=\"margin: 0px 13px; width: 150px; height: 100px; text-align: center; background-image: url({{ slide.ImageUrl }}); background-size: cover; display: inline-block; cursor: pointer\"> <span style=\"color: #FFF; padding-top: 65px; float: left; width: 100%\"> {{ slide.LinkText }} </span> </a></div> </div> </div>  </web-component>";
var id1="winresReservationTypes.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationTypes/winresReservationTypes.html
// module id = 430
// module chunks = 2